import { createFileRoute } from "@tanstack/react-router"
import DesignSystemMatrix from "~/pages/design-system/components/Matrix"

export const Route = createFileRoute("/_auth/internal/design-system/components/matrix")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemMatrix />
}
